import { BaseDestinationItem } from '@/features/destinations/commons';
import { CustomConnectorDto } from '@/models/connectors';
import { FC } from 'react';
import { CustomConnectorConnectionToggle } from './CustomConnectorConnectionToggle';

type CustomConnectorDestinationItemProps = {
  connector: CustomConnectorDto;
};

export const CustomConnectorDestinationItem: FC<CustomConnectorDestinationItemProps> = ({ connector }) => {
  const connectorWithIcon = {
    ...connector,
    icon: `data:image/png;base64,${connector.authConfiguration.configurations[0].elements.auth.config['image']}` || '/assets/icons/default-connector.svg',
  };

  return (
    <BaseDestinationItem connector={connectorWithIcon}>
      <CustomConnectorConnectionToggle connector={connector} deauthenticateDisabled={false} />
    </BaseDestinationItem>
  );
};
